
<div fxLayout="column">
    <div class="wysiwyg" fxFlex="100" floatLabel="never">
        <span title="{{user.author_name}}" class="user-{{user.role}}">{{user.abbreviation}}</span>
        <richtext
            class="comments-input"
            placeholder="Take a note..."
            [(value)]="newCommentHTML"
            [enableReturn]="true"
            name="notesComponentInput"
            id="notesComponentInput{{notesComponentInput}}">
        </richtext>
        <button class="button" (click)="addComment()">Add Note</button>
    </div>
    <div fxFlex="100" *ngFor="let comment of comments" class="comment mat-{{comment.role}}-border">
            <span title="{{comment.author_name}}" class="user-{{comment.role}}">{{comment.abbreviation}}</span> <span class="date">{{comment.date | date:'L/d \'at\' h:mma'}}</span>
        <div class="spacer"></div><span class="comment-text" [innerHtml]="linkifyHtml(comment.text)"></span>
    </div>
</div>